<h2 mat-dialog-title id="complete-title" matDialogTitle>
  Complete {{ delivery.type }} :
</h2>

<mat-dialog-content>
  <div class="py-3" *ngIf="warningMessage">
    <app-alert-text title="Warning" [testId]="'delivery-warning'" type="warning">
      <p testId="delivery-warning-message">{{ warningMessage }}</p>
    </app-alert-text>
  </div>
  <table class="table mb-5 overflow-x-auto" id="items" data-cy="complete-delivery-items-table">
    <thead>
      <tr>
        <th>Items</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of items | async" data-cy="complete-delivery-item-row">
        <td>{{ item }}</td>
      </tr>
    </tbody>
  </table>
  <div [formGroup]="form" class="flex flex-col md:flex-row md:space-x-4 md:items-center">
    <mat-form-field fxFlex="50">
      <mat-label>Completed Date</mat-label>
      <input matInput formControlName="completed_date" [matDatepicker]="picker" id="date" autocomplete="off"
        placeholder="Date" required />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <mat-form-field fxFlex="50">
      <mat-label>Completed time</mat-label>
      <input matInput name="completed_time" formControlName="completed_time"
        (blur)="updateTimeEnteredManually('completed_time', pickerOff)" placeholder="Completed time" />
      <mat-error *ngIf="form.get('completed_time').hasError('invalidTime')">Invalid time value, please enter in the
        format: HH:mm (24
        hour)</mat-error>
      <mat-icon matSuffix (click)="pickerOff.open()">access_time</mat-icon>
    </mat-form-field>
    <ngx-mat-timepicker [format]="24" enableKeyboardInput dottedMinutesInGap
      (timeSet)="updateTime($event, 'completed_time')" #pickerOff></ngx-mat-timepicker>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button id="cancel-complete" mat-button mat-dialog-close>Cancel</button>
  <button id="confirm-complete" mat-raised-button color="primary" [disabled]="!form.valid || (saving$ | async)"
    (click)="save()">
    Save
  </button>
</mat-dialog-actions>